import moment from 'moment';

export const momentFormatDate = date => moment(date).format('YYYY-MM-DD');

export const momentFormatDateWithTime = date => moment(date).format('YYYY-MM-DD HH:MM:SS');

